// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Styles
import './Steps.scss'

function Steps({ stepsLength, current, ...props }) {
  return (
    <div className="steps-wrapper" {...props}>
      {[...Array(stepsLength)].map((_, index) => {
        const isActive = index <= current - 1

        return (
          <div
            className={`
              __step
              ${isActive ? '--active' : ''}
            `}
            key={index}
          >
            <div className="__divider" />
            <div className="__dot" />
          </div>
        )
      })}
    </div>
  )
}

Steps.propTypes = {
  stepsLength: PropTypes.number,
  current: PropTypes.number,
}

Steps.defaultProps = {
  stepsLength: 1,
  current: 1,
}

export default Steps
